import asyncComponent from '../common/utils/async-component.js';

const Webhooks = asyncComponent(() => import('./components/webhooks/index.js'));

export default {
  '/webhooks': {
    components: { main: Webhooks }
  }
};
